import React from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";

import { selectStep } from "../userSlice";
// import {}

const Progress = (): JSX.Element => {
  const step = useAppSelector(selectStep);
  console.log("==", step);
  return (
    <div>
      <div className="p-5 bg-white">
        <div className="mx-4 p-8">
          <div className="flex items-center">
            <div className="flex items-center text-teal-600 relative">
              <div
                className={`rounded-full transition duration-500 ease-in-out h-2.5 w-2.5 bg-teal-600 ${
                  step === 1 ? "bg-black-point" : "invisible"
                }`}
              />
              <div className="absolute top-0 -ml-14 text-center mt-7 w-32 text-xs font-medium uppercase text-teal-600">
                Amount
              </div>
            </div>
            <div
              className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
                step > 1 ? "border-blue" : "border-grey-blur"
              }`}
            />
            <div className="flex items-center text-teal-600 relative">
              <div
                className={`rounded-full transition duration-500 ease-in-out h-2.5 w-2.5 bg-teal-600 ${
                  step === 2 ? "bg-black-point" : "invisible"
                }`}
              />
              <div className="absolute top-0 -ml-14 text-center mt-7 w-32 text-xs font-medium uppercase text-teal-600">
                Recipient
              </div>
            </div>
            <div
              className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
                step > 2 ? "border-blue" : "border-grey-blur"
              }`}
            />
            <div className="flex items-center text-gray-500 relative">
              <div
                className={`rounded-full transition duration-500 ease-in-out h-2.5 w-2.5 bg-teal-600 ${
                  step === 3 ? "bg-black-point" : "invisible"
                }`}
              />
              <div className="absolute top-0 -ml-14 text-center mt-7 w-32 text-xs font-medium uppercase text-gray-500">
                Review
              </div>
            </div>
            <div
              className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
                step > 3 ? "border-blue" : "border-grey-blur"
              }`}
            />
            <div className="flex items-center text-gray-500 relative">
              <div
                className={`rounded-full transition duration-500 ease-in-out h-2.5 w-2.5 bg-teal-600 ${
                  step === 4 ? "bg-black-point" : "invisible"
                }`}
              />
              <div className="absolute top-0 -ml-14 text-center mt-7 w-32 text-xs font-medium uppercase text-gray-500">
                Pay
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Progress;
